/* eslint-disable array-callback-return */
import { Modal } from "react-bootstrap";
import {
  popCancelBttn,
  exclaimIcn,
  imsLoader
} from "../../assets";
import { Component } from "react";
import Button from "../Button";
import ApiServices from "../../utils/apiServices";
import RenameReadingListPopup from "../PopUp/RenameReadingListPopup";
import GenAIRenameReadingListPopup from "./GenAIRenameReadingListPopup";
import { v4 as uuidv4 } from "uuid";
import SuccessReadingList from "../PopUp/SucessReadingList";
import SucessCommonPopup from "./SucessCommonPopup";
import { snippetLongString } from "../../utils/utilityServices";
import "../PopUp/GlobalSearchFeaturesPopUp.css";
import "./GenAIPinToReadingListPopUp.css";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
import ConfirmMessagePopUpModal from "./ConfirmMessagePopUpModal"
import moment from 'moment';

class GenAIReadingListPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPop: false,
      isPin: true,
      isinfo: true,
      isManage: false,
      apiResponse: [],
      isLoaded: false,
      showRenamePop: false,
      itemtoBeRenamedName: "",
      itemtoBeRenamedID: "",
      error: "",
      readingListName: "",
      docID: [],
      showSuccess: false,
      isInsertSuccess: false,
      selectedReadingLists: [],
      successMessage: "",
      nodeName: "",
      alertMessageModelColor: "",
      alertMessageContent: "",
      alertMessageShowModal: false,
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageId: -1,
    };
  }
  async componentDidMount() {
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    if (
      this.props.selectedResults.length <= 0 ||
      this.props.selectedResults.length > 200
    ) {
      this.setState({
        isManage: true,
        isPin: false,
        isinfo: false,
      });
    } else {
      this.setState({
        docID: this.props.selectedResults.map((item) => item.detail.searchID),
      });
    }
    this.setState({
      showPop: this.props.showModal,
    });
    let apiRes = await service.getReadingLists(username);
    this.setState(
      {
        apiResponse: apiRes,
        //isLoaded: true
      },
      async () => {
        await this.getReadingListsWithDocIds();
      }
    );
  }

  showConfirmMessage = (message, id) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageId: id
    })
  }

  confirmHandler = async () => {
    const { confirmMessageId } = this.state;
    let username = JSON.parse(localStorage.getItem('username'))
    if (username) {
      username = username.toLowerCase();
    }
    let service = new ApiServices();
    await service.deleteReadingLists(confirmMessageId, username);
    this.setState(
      {
        isLoaded: false,
        confirmMessageContent: "",
        confirmMessageShowModal: false,
        confirmMessageId: -1
      },
      async () => {
        let { selectedReadingLists } = this.state
        let apiRes = await service.getReadingLists(username);
        let readinglistIds = apiRes.map(x => x.readinglist_id);
        selectedReadingLists = selectedReadingLists.filter(x => readinglistIds.includes(x.readinglist_id));
        this.setState(
          {
            apiResponse: apiRes,
            isLoaded: true,
            selectedReadingLists: selectedReadingLists
          },
          async () => {
            await this.getReadingListsWithDocIds();
          }
        );
      }
    );
  }

  closeConfirmMessage = () => {
    this.setState({
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    })
  }
  errorAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#de1327",
      alertMessageShowModal: true
    })
  }

  closeAlertMessage = () => {
    this.setState({
      alertMessageContent: "",
      alertMessageModelColor: "",
      alertMessageShowModal: false
    })
  }
  getReadingListsWithDocIds = async () => {
    let { apiResponse } = this.state;
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    let apiRes = await service.getReadingListsWithDocIds(username);
    let doneArr = [];
    if (apiRes) {
      apiRes.map((item) => {
        let _docCount = item.doc_id.split(";").length;
        if (!doneArr.find((x) => x === item.readinglist_id)) {
          _docCount += this.props.selectedResults.length;

          let _selectedReadingList = apiResponse.find(
            (x) => x.readinglist_id === item.readinglist_id
          );

          _selectedReadingList.docCount =
            _selectedReadingList.docCount === undefined
              ? _docCount
              : _selectedReadingList.docCount + _docCount;

          _selectedReadingList.doc_id = item.doc_id;
        } else {
          let _selReadList = apiResponse.find(
            (x) => x.readinglist_id === item.readinglist_id
          );

          _selReadList.doc_id =
            _selReadList.doc_id !== undefined
              ? _selReadList.doc_id + ";" + item.doc_id
              : item.doc_id;

          _selReadList.doc_id = Array.from(
            new Set(_selReadList.doc_id.split(";"))
          );

          _selReadList.docCount =
            _selReadList.doc_id.length + this.props.selectedResults.length;
        }

        doneArr.push(item.readinglist_id);
      });
      this.setState({
        apiResponse: apiResponse,
        isLoaded: true,
      });
    }
  };

  handleOnClickView = async (rlID, rName) => {
    let ids = "";
    let service = new ApiServices();
    let res = await service.getDocIds(rlID);
    if (res.length > 0) {
      ids = res.map(item => item.doc_id).filter(x => x).join(";");
      // res.map((item) => {
      //   ids += `${item.doc_id};`;
      //   return null;
      // });
    }
    localStorage.setItem("readListDocIds", ids);
    localStorage.setItem("rLID", rlID);
    localStorage.setItem("rName", rName);
    let url = `/viewReadingList?query=&q=All%20Fields&filters=&f1=searchID&fval1=${ids}&fcount=1&rName=${encodeURIComponent(
      rName
    )}&rID=${rlID}`;
    if (ids !== "") {
      window.open(url, "_blank");
    } else {
      this.errorAlertMessage("You do not have any items pinned to this reading list.");
    }
  };
  handleRename = (id, name) => {
    this.setState({
      showRenamePop: true,
      itemtoBeRenamedName: name,
      itemtoBeRenamedID: id,
    });
  };
  handleRenameClose = (status) => {
    this.setState(
      {
        showRenamePop: status,
        isLoaded: false,
      },
      async () => {
        let username = JSON.parse(
          localStorage.getItem("username")
        ).toLowerCase();
        let service = new ApiServices();
        let apiRes = await service.getReadingLists(username);
        this.setState(
          {
            apiResponse: apiRes,
            //isLoaded: true
          },
          async () => {
            await this.getReadingListsWithDocIds();
          }
        );
      }
    );
  };
  handleRemove = async (id) => {
    this.showConfirmMessage("Are you sure you want to delete this reading list ?", id)
  };
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let readingList = this.state.apiResponse.map((data) =>
      data.readinglist_name.toLowerCase()
    );
    if ((this.state.readingListName.length <= 0
      || (this.state.readingListName && this.state.readingListName.trim().length <= 0))
      &&
      this.state.selectedReadingLists.length <= 0 &&
      this.state.nodeName !== "INPUT"
    ) {
      formIsValid = false;
      this.errorAlertMessage("Please enter either New Reading List name or select any Existing reading list to proceed.")
      // errors["pinReadingList"] = 'Please enter a valid name to proceed.';
    }
    if (
      (this.state.readingListName.length <= 0
        || (this.state.readingListName && this.state.readingListName.trim().length <= 0)) &&
      this.state.nodeName === "INPUT" &&
      this.state.selectedReadingLists.length <= 0
    ) {
      formIsValid = false;
      errors["pinReadingList"] = `Please enter a valid name to proceed.`;
    }
    if (readingList.includes(this.state.readingListName.toLowerCase())) {
      formIsValid = false;
      errors[
        "pinReadingList"
      ] = `You already have a reading list with entered title. Please enter a new title.`;
    }
    this.setState({ error: errors });
    return formIsValid;
  }
  handleCheckBox = (e, itemCounts) => {
    if (itemCounts <= 200 || itemCounts === undefined) {
      let arr = this.state.selectedReadingLists;
      if (e.target.checked) {
        arr.push(e.target.value);
      } else {
        var idx = arr.indexOf(e.target.value);
        if (idx !== -1) {
          arr.splice(idx, 1);
        }
      }
      this.setState({
        selectedReadingLists: arr,
      });
    } else {
      e.preventDefault();
      e.returnValue = false;
      this.errorAlertMessage("A user may only add a maximum of 200 items in a reading list.");
    }

  };
  handleClickCheckBox = (e, itemCounts) => {
    if (itemCounts <= 200 || itemCounts === undefined) {
      let arr = this.state.selectedReadingLists;
      if (e.target.checked) {
        arr.push(e.target.value);
      } else {
        var idx = arr.indexOf(e.target.value);
        if (idx !== -1) {
          arr.splice(idx, 1);
        }
      }
      this.setState({
        selectedReadingLists: arr,
      });
    } else {
      e.stopPropagation();
      e.preventDefault();
      e.returnValue = false;
      this.errorAlertMessage("A user may only add a maximum of 200 items in a reading list.");
    }

  };
  handleOnFocusInput = (e) => {
    this.setState({ nodeName: e.target.nodeName });
  };
  handleInput = (e) => {
    e.target.value = snippetLongString(e.target.value);
    this.setState({
      readingListName: e.target.value,
    });
  };
  onclickProceed = async () => {
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    let docIDs = this.state.docID.join(";");
    if (this.handleValidation()) {
      if (this.state.readingListName !== "") {
        let listID = uuidv4();
        await service.insertUpdateReadingList(
          this.state.readingListName,
          `RL_${listID}`,
          username,
          docIDs
        );
        //console.log("ID:"+`RL_${listID}`+" Name:"+this.state.readingListName+" Doc ID:"+this.state.docID)
        this.setState({
          successMessage:
            "The result/selection was pinned successfully to new Reading List.",
        });
      }
      if (this.state.selectedReadingLists.length > 0) {
        for (const itr of this.state.selectedReadingLists) {
          let rlName = this.state.apiResponse.find(
            (e) => e.readinglist_id === itr
          );
          //console.log(rlName.readinglist_name)
          await service.insertUpdateReadingList(
            rlName.readinglist_name,
            itr,
            username,
            docIDs
          );
        }
        this.setState({
          successMessage:
            "The result/selection was pinned successfully to selected existing Reading List(s).",
        });
      }
      if (
        this.state.readingListName !== "" &&
        this.state.selectedReadingLists.length > 0
      ) {
        this.setState({
          successMessage:
            "The result/selection was pinned successfully to selected existing Reading List(s) and the new reading list.",
        });
      }
      this.setState({
        showSuccess: true,
        isInsertSuccess: true
      });
    }
  };
  handleSuccessClose = async (status) => {
    this.setState({
      showSuccess: status,
      //showPop: false,
      isManage: true,
      isPin: false,
      isinfo: false,
      isLoaded: false
    },
      async () => {
        let username = JSON.parse(
          localStorage.getItem("username")
        ).toLowerCase();
        let service = new ApiServices();
        let apiRes = await service.getReadingLists(username);
        this.setState(
          {
            apiResponse: apiRes,
          },
          async () => {
            await this.getReadingListsWithDocIds();
          }
        );
      });
    //this.props.handleClose(false);
  };
  render() {
    const { alertMessageModelColor, alertMessageContent, alertMessageShowModal, isInsertSuccess } = this.state;
    const { confirmMessageContent, confirmMessageShowModal } = this.state;
    if (this.props.width <= 600) {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            scrollable={true}
          >
            <div>
              {this.state.isLoaded ? (
                <>
                  {(this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0 ? (
                    <div
                      style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}
                    >
                      <Modal.Header
                        className="gsfModalHeader"
                        style={{ justifyContent: "left", padding: "0.5rem 0" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            paddingTop: "1%",
                          }}
                        >
                          <Modal.Title>
                            <div className="actionItem-headerPart">
                              {this.props.selectedResults.length > 0 &&
                                this.props.selectedResults.length <= 200 && !isInsertSuccess && (
                                  <div
                                    onClick={(e) => {
                                      this.setState({
                                        isPin: true,
                                        isManage: false,
                                        isinfo: true,
                                      });
                                    }}
                                    className={
                                      this.state.isPin
                                        ? "active-pin-features-button"
                                        : "pin-features-buttons"
                                    }
                                    style={{ margin: "1% 0" }}
                                  >
                                    <span>Pin to Reading List</span>
                                  </div>
                                )}
                              <div
                                onClick={(e) => {
                                  this.setState({ isPin: false, isManage: true });
                                }}
                                className={
                                  this.state.isManage
                                    ? "active-pin-features-button"
                                    : "pin-features-buttons"
                                }
                                style={{
                                  margin: "1% 0",
                                }} /* className="active-pin-features-button" */
                              >
                                <span>View/Manage Reading Lists</span>
                              </div>
                            </div>
                          </Modal.Title>
                        </div>
                      </Modal.Header>
                      <Modal.Body scrollable={true} style={{ height: "45vh" }}>
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                <span style={{ color: "black" }}>
                                  My Reading Lists
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="reading-list-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li key={item.readinglist_id}>
                                            <span>
                                              <input
                                                // disabled={item.docCount > 200}
                                                title={
                                                  item.docCount > 200
                                                    ? "A user may only add a maximum of 200 items in a reading list."
                                                    : ""
                                                }
                                                type="checkbox"
                                                value={item.readinglist_id}
                                                className="reading-list-checkbox-wrapper"
                                                onChange={e => this.handleCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.readinglist_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any reading lists
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br />
                                <div>
                                  Create A New Reading List By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.readingListName}
                                  className="reading-list-input-box"
                                  onChange={this.handleInput}
                                  onFocus={this.handleOnFocusInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinReadingList"]}
                                </div>
                                <br />
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <table className="reading-list-view-wrapper">
                                      <tr>
                                        <th style={{ color: "#333" }}>
                                          Reading List Name
                                        </th>
                                        <th
                                          style={{
                                            textAlign: "center",
                                            color: "#333",
                                          }}
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                      <tbody>
                                        {this.state.apiResponse.map((item) => {
                                          return (
                                            <tr key={item.readinglist_id}>
                                              <td>{item.readinglist_name}</td>
                                              <td
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span
                                                  onClick={(e) =>
                                                    this.handleOnClickView(
                                                      item.readinglist_id,
                                                      item.readinglist_name
                                                    )
                                                  }
                                                  title="View"
                                                  className="reading-list-action-text"
                                                >
                                                  View
                                                </span>
                                                <span
                                                  onClick={(e) =>
                                                    this.handleRename(
                                                      item.readinglist_id,
                                                      item.readinglist_name
                                                    )
                                                  }
                                                  title="Edit"
                                                  className="reading-list-action-text"
                                                >
                                                  Edit
                                                </span>
                                                <span
                                                  title="Remove"
                                                  className="reading-list-action-text"
                                                  onClick={(e) =>
                                                    this.handleRemove(
                                                      item.readinglist_id
                                                    )
                                                  }
                                                >
                                                  Remove
                                                </span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    {this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Reading list' select the items that should be maximum upto 200.</span>}
                                  </span>
                                ) : (
                                  <span>
                                    {" "}
                                    You currently do not have any reading lists
                                    created.
                                  </span>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Modal.Body>
                      {this.state.isPin ? (
                        <div className="pin-popup-button-wrapper">
                          {/* <div style={{margin:"1% 0"}}> */}
                          <button
                            className="pin-pop-up-button-cancel"
                            onClick={(e) => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          >
                            Cancel
                          </button>
                          {/* <Button text="Cancel" customColor="#000000" action={() => { this.setState({ showPop: false });this.props.handleClose(false); }} /> */}
                          {/* </div>
                    <div style={{margin:"1% 0"}}> */}
                          <button
                            className="pin-pop-up-button-proceed"
                            onClick={(e) => {
                              this.onclickProceed();
                            }}
                          >
                            Pin
                          </button>
                          {/* <Button text="Pin" customColor="#EB1700" action={this.onclickProceed} /> */}
                          {/* </div> */}
                        </div>
                      ) : (
                        <div className="pin-popup-button-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ borderLeft: `5px solid #0074B0` }}>
                      {/* <div className="popup-cancel-btn-wrapper">
                        <img src={popCancelBttn} alt="" onClick={(e)=>{this.setState({showPop:false});this.props.handleClose(false)}}/>
                    </div> */}
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Reading Lists
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "35vh" }}
                        >
                          <div>
                            It looks like you don't have any reading lists created
                            yet. Please use 'Pin' from the desired result/select a
                            few and then click on 'Reading List' icon.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SuccessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenameReadingListPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
        </>
      );
    } else if (this.props.width <= 1000 && this.props.width > 600) {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            scrollable={true}
          >
            <div>
              {this.state.isLoaded ? (
                <>
                  {(this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0 ? (
                    <div
                      style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}
                    >
                      <Modal.Header
                        className="gsfModalHeader"
                        style={{ justifyContent: "left", padding: "0.5rem 0" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            paddingTop: "1%",
                          }}
                        >
                          <Modal.Title>
                            <div className="actionItem-headerPart">
                              {this.props.selectedResults.length > 0 &&
                                this.props.selectedResults.length <= 200 && !isInsertSuccess && (
                                  <>
                                    <div
                                      onClick={(e) => {
                                        this.setState({
                                          isPin: true,
                                          isManage: false,
                                          isinfo: true,
                                        });
                                      }}
                                      className={
                                        this.state.isPin
                                          ? "active-pin-features-button"
                                          : "pin-features-buttons"
                                      }
                                      style={{ margin: "1% 0" }}
                                    >
                                      <span>Pin to Reading List</span>
                                    </div>
                                    <div className="action-button-saperation-line"></div>
                                  </>
                                )}
                              <div
                                onClick={(e) => {
                                  this.setState({ isPin: false, isManage: true });
                                }}
                                className={
                                  this.state.isManage
                                    ? "active-pin-features-button"
                                    : "pin-features-buttons"
                                }
                                style={{
                                  margin: "1% 0",
                                }} /* className="active-pin-features-button" */
                              >
                                <span>View/Manage Reading Lists</span>
                              </div>
                            </div>
                          </Modal.Title>
                        </div>
                      </Modal.Header>
                      <Modal.Body scrollable={true} style={{ height: "45vh" }}>
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                <span style={{ color: "black" }}>
                                  My Reading Lists
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="reading-list-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li key={item.readinglist_id}>
                                            <span>
                                              <input
                                                // disabled={item.docCount > 200}
                                                title={
                                                  item.docCount > 200
                                                    ? "A user may only add a maximum of 200 items in a reading list."
                                                    : ""
                                                }
                                                type="checkbox"
                                                value={item.readinglist_id}
                                                className="reading-list-checkbox-wrapper"
                                                onChange={e => this.handleCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.readinglist_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any reading lists
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br />
                                <div>
                                  Create A New Reading List By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.readingListName}
                                  className="reading-list-input-box"
                                  onChange={this.handleInput}
                                  onFocus={this.handleOnFocusInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinReadingList"]}
                                </div>
                                <br />
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <table className="reading-list-view-wrapper">
                                      <tr>
                                        <th>Reading List Name</th>
                                        <th style={{ textAlign: "center" }}>
                                          Date Saved
                                        </th>
                                        <th style={{ textAlign: "center" }}>
                                          Actions
                                        </th>
                                      </tr>
                                      <tbody>
                                        {this.state.apiResponse.map((item) => {
                                          return (
                                            <tr key={item.readinglist_id}>
                                              <td>{item.readinglist_name}</td>
                                              <td style={{ textAlign: "center" }}>
                                                {moment(item.added_on).format("D-MMM-YYYY")}
                                              </td>
                                              <td
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  onClick={(e) =>
                                                    this.handleOnClickView(
                                                      item.readinglist_id,
                                                      item.readinglist_name
                                                    )
                                                  }
                                                  title="View"
                                                  className="reading-list-action-text"
                                                >
                                                  View
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  onClick={(e) =>
                                                    this.handleRename(
                                                      item.readinglist_id,
                                                      item.readinglist_name
                                                    )
                                                  }
                                                  title="Edit"
                                                  className="reading-list-action-text"
                                                >
                                                  Edit
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  title="Remove"
                                                  className="reading-list-action-text"
                                                  onClick={(e) =>
                                                    this.handleRemove(
                                                      item.readinglist_id
                                                    )
                                                  }
                                                >
                                                  Remove
                                                </span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    {this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Reading list' select the items that should be maximum upto 200.</span>}
                                  </span>
                                ) : (
                                  <span>
                                    {" "}
                                    You currently do not have any reading lists
                                    created.
                                  </span>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Modal.Body>
                      {this.state.isPin ? (
                        <div
                          className="gsf-popup-button-wrapper"
                          style={{ width: "40%" }}
                        >
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                          <Button
                            text="Pin"
                            customColor="#EB1700"
                            action={this.onclickProceed}
                          />
                        </div>
                      ) : (
                        <div className="reading-list-button-tablet-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ borderLeft: `5px solid #0074B0` }}>
                      {/* <div className="popup-cancel-btn-wrapper">
                        <img src={popCancelBttn} alt="" onClick={(e)=>{this.setState({showPop:false});this.props.handleClose(false)}}/>
                    </div> */}
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Reading Lists
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "35vh" }}
                        >
                          <div>
                            It looks like you don't have any reading lists created
                            yet. Please use 'Pin' from the desired result/select a
                            few and then click on 'Reading List' icon.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SuccessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenameReadingListPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
        </>
      );
    } else {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            scrollable={true}
          >
            <div className="gen-ai-common-popup">
              {this.state.isLoaded ? (
                <>
                  {((this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0) ? (<>

                      <div className="gen-ai-common-popup__top-row">
                        <div className="gen-ai-common-popup__tabs">
                          {this.props.selectedResults.length > 0 &&
                            this.props.selectedResults.length <= 200 && !isInsertSuccess && (
                              <button
                                onClick={(e) => {
                                  this.setState({
                                    isPin: true,
                                    isManage: false,
                                    isinfo: true,
                                  });
                                }}
                                className={`gen-ai-common-popup__tab ${this.state.isPin ? "gen-ai-common-popup__tab--active" : ""}`}>
                                Pin to Reading List</button>

                            )}
                          <button
                            onClick={(e) => {
                              this.setState({ isPin: false, isManage: true });
                            }}
                            className={`gen-ai-common-popup__tab ${this.state.isManage ? "gen-ai-common-popup__tab--active" : ""}`}>
                            View/Manage Reading Lists</button>
                        </div>

                        <div className="gen-ai-common-popup__icon-area" onClick={(e) => {
                          this.setState({ showPop: false });
                          this.props.handleClose(false);
                        }} aria-hidden="true">
                          <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </div>
                      </div>
                      <div className="gen-ai-common-popup__body">
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                <span style={{ color: "black" }}>
                                  My Reading Lists
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="reading-list-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li
                                            className="readinglistCheckBox"
                                            key={item.readinglist_id}
                                          >
                                            <span>
                                              <input
                                                // disabled={item.docCount > 200}
                                                title={
                                                  item.docCount > 200
                                                    ? "A user may only add a maximum of 200 items in a reading list."
                                                    : ""
                                                }
                                                type="checkbox"
                                                value={item.readinglist_id}
                                                className="reading-list-checkbox-wrapper"
                                                // onChange={e => this.handleCheckBox(e, item.docCount)}
                                                onClick={e => this.handleClickCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.readinglist_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any reading lists
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br />
                                <div>
                                  Create A New Reading List By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.readingListName}
                                  className="reading-list-input-box"
                                  onFocus={this.handleOnFocusInput}
                                  onChange={this.handleInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinReadingList"]}
                                </div>
                                <br />
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div className="gen-ai-common-popup--list">
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <div className="gen-ai-common-popup__inner">
                                    <div className="gen-ai-common-popup__header-row" role="row">
                                      <div className="gen-ai-common-popup__header gen-ai-common-popup__header--name">Reading List Name</div>
                                      <div className="gen-ai-common-popup__header gen-ai-common-popup__header--date">Date Saved</div>
                                      <div className="gen-ai-common-popup__header gen-ai-common-popup__header--actions" aria-hidden>
                                        Actions
                                      </div>
                                    </div>
                                    <ul className="gen-ai-common-popup__list" role="list">
                                      {this.state.apiResponse.map((item, index) => (
                                        <li className="gen-ai-common-popup__row" key={item.readinglist_id} role="listitem">
                                          <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--name">
                                            <span className="gen-ai-common-popup__link-name">{item.readinglist_name}</span>
                                          </div>
                                          <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--date">
                                            <span className="gen-ai-common-popup__date">{moment(item.added_on).format("D-MMM-YYYY")}</span>
                                          </div>
                                          <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--actions">
                                            <div className="gen-ai-common-popup__actions">
                                              <button
                                                type="button"
                                                className="gen-ai-common-popup__icon-btn"
                                                title="View"
                                                onClick={(e) =>
                                                  this.handleOnClickView(
                                                    item.readinglist_id,
                                                    item.readinglist_name
                                                  )
                                                }>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <g clip-path="url(#clip0_1683_4216)">
                                                    <path d="M1.61341 8.47537C1.52262 8.33161 1.47723 8.25973 1.45182 8.14886C1.43273 8.06559 1.43273 7.93425 1.45182 7.85097C1.47723 7.74011 1.52262 7.66823 1.61341 7.52447C2.36365 6.33648 4.59682 3.33325 8.00004 3.33325C11.4033 3.33325 13.6364 6.33648 14.3867 7.52447C14.4775 7.66823 14.5228 7.74011 14.5483 7.85097C14.5673 7.93425 14.5673 8.06559 14.5483 8.14886C14.5228 8.25973 14.4775 8.33161 14.3867 8.47537C13.6364 9.66336 11.4033 12.6666 8.00004 12.6666C4.59682 12.6666 2.36365 9.66336 1.61341 8.47537Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.00004 9.99992C9.10457 9.99992 9.99997 9.10449 9.99997 7.99992C9.99997 6.89535 9.10457 5.99992 8.00004 5.99992C6.89551 5.99992 6.00011 6.89535 6.00011 7.99992C6.00011 9.10449 6.89551 9.99992 8.00004 9.99992Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_1683_4216">
                                                      <rect width="15.9994" height="16" rx="4" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                              </button>
                                              <button
                                                type="button"
                                                className="gen-ai-common-popup__icon-btn"
                                                onClick={(e) =>
                                                  this.handleRename(
                                                    item.readinglist_id,
                                                    item.readinglist_name
                                                  )
                                                }
                                                title="Rename">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <g clip-path="url(#clip0_1761_5055)">
                                                    <path d="M1.91725 12.0771C1.94788 11.8014 1.96319 11.6636 2.0049 11.5347C2.0419 11.4205 2.09417 11.3117 2.16031 11.2114C2.23485 11.0983 2.33291 11.0003 2.52902 10.8042L11.3329 1.99998C12.0693 1.2636 13.2631 1.2636 13.9995 1.99998C14.7358 2.73636 14.7358 3.93027 13.9995 4.66665L5.19559 13.4708C4.99948 13.6669 4.90142 13.765 4.78838 13.8396C4.68809 13.9057 4.57932 13.958 4.46503 13.995C4.33621 14.0367 4.19838 14.052 3.92273 14.0826L1.66656 14.3333L1.91725 12.0771Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_1761_5055">
                                                      <rect width="15.9994" height="16" rx="4" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                              </button>
                                              <button
                                                type="button"
                                                className="gen-ai-common-popup__icon-btn"
                                                onClick={(e) =>
                                                  this.handleRemove(
                                                    item.readinglist_id
                                                  )
                                                }
                                                title="Delete"
                                              >
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M10.6664 3.99992V3.46659C10.6664 2.71985 10.6664 2.34648 10.521 2.06126C10.3932 1.81038 10.1892 1.60641 9.93837 1.47858C9.65317 1.33325 9.27981 1.33325 8.5331 1.33325H7.46647C6.71976 1.33325 6.34641 1.33325 6.0612 1.47858C5.81033 1.60641 5.60636 1.81038 5.47854 2.06126C5.33322 2.34648 5.33322 2.71985 5.33322 3.46659V3.99992M2 3.99992H13.9996M12.6663 3.99992V11.4666C12.6663 12.5867 12.6663 13.1467 12.4483 13.5746C12.2566 13.9509 11.9506 14.2569 11.5743 14.4486C11.1465 14.6666 10.5865 14.6666 9.4664 14.6666H6.53317C5.41311 14.6666 4.85308 14.6666 4.42527 14.4486C4.04896 14.2569 3.74301 13.9509 3.55127 13.5746C3.33329 13.1467 3.33329 12.5867 3.33329 11.4666V3.99992" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                              </button>
                                            </div>
                                          </div>
                                        </li>
                                      ))}
                                    </ul>
                                    {this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Reading list' select the items that should be maximum upto 200.</span>}
                                  </div>
                                ) : (
                                  <div className="gen-ai-common-popup__inner">
                                    {(this.props.selectedResults &&
                                      this.props.selectedResults.length > 200) ? <> {" "}
                                      To Pin/Create the 'Reading list' select the items that should be maximum upto 200.</> :
                                      <>{" "}You currently do not have any reading lists created.</>}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="gen-ai-common-popup__footer">
                        {this.state.isPin ? (<>
                          <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline" onClick={() => {
                            this.setState({ showPop: false });
                            this.props.handleClose(false);
                          }}
                          >Close</button>
                          <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--primary" onClick={this.onclickProceed}>
                            Pin
                          </button>

                        </>
                        ) : (
                          <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline" onClick={() => {
                            this.setState({ showPop: false });
                            this.props.handleClose(false);
                          }}>
                            Cancel
                          </button>

                        )}
                      </div>
                    </>

                  ) : (<>
                    <div className="gen-ai-common-popup__top-row">
                      <div className=""></div>
                      <div className="gen-ai-common-popup__icon-area" onClick={(e) => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }} aria-hidden="true">
                        <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>

                    </div>
                    <div className="gen-ai-common-popup__body">
                      <div style={{ textAlign: "center", borderBottom: "2px solid #EB1700" }}>
                        <Modal.Title>
                          <div>
                            <svg width="55px" height="55px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#EB1700" fill-rule="evenodd" d="M10 3a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0zm10.01 4a1 1 0 01-1 1H10a1 1 0 110-2h.01a1 1 0 011 1zM11 6a1 1 0 10-2 0v5a1 1 0 102 0V6z"></path> </g></svg>
                          </div>
                          <span style={{ color: "#EB1700" }}>
                            No Reading Lists
                          </span>
                        </Modal.Title>
                      </div>
                      <div style={{ padding: "0 20px" }}>
                        It looks like you don't have any reading lists created
                        yet. Please use 'Pin' from the desired result/select a
                        few and then click on 'Reading List' icon.
                      </div>
                    </div>
                    <div className="gen-ai-common-popup__footer">
                      <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline" onClick={() => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }}>
                        Cancel
                      </button>
                    </div>
                    {/* <div style={{ borderLeft: `5px solid #0074B0` }}>
                      <div className="popup-cancel-btn-wrapper">
                        <img
                          src={popCancelBttn}
                          alt=""
                          onClick={(e) => {
                            this.setState({ showPop: false });
                            this.props.handleClose(false);
                          }}
                        />
                      </div>
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Reading Lists
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "25vh" }}
                        >
                          <div>
                            It looks like you don't have any reading lists created
                            yet. Please use 'Pin' from the desired result/select a
                            few and then click on 'Reading List' icon.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div> */}
                  </>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SucessCommonPopup
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <GenAIRenameReadingListPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
        </>
      );
    }
  }
}
export default GenAIReadingListPopup;
